class UiSwitch extends HTMLElement {
       static get observedAttributes() {
      return ['checked', 'disabled', 'label', 'label-left'];
    }
 
    get checked() {
      return this.hasAttribute('checked');
    }
 
    set checked(value) {
      if (value) {
        this.setAttribute('checked', '');
      } else {
        this.removeAttribute('checked');
      }
    }
 
    get disabled() {
      return this.hasAttribute('disabled');
    }
 
    set disabled(value) {
      if (value) {
        this.setAttribute('disabled', '');
      } else {
        this.removeAttribute('disabled');
      }
    }
 
    connectedCallback() {
      this._render();
      this._bindEvents();
    }
 
    disconnectedCallback() {
      if (this._track) {
        this._track.removeEventListener('click', this._onClick);
        this._track.removeEventListener('keydown', this._onKeyDown);
      }
    }
 
    attributeChangedCallback() {
      if (this._track) {
        this._update();
      }
    }
 
    _render() {
      var ll = this.getAttribute('label-left') || '';
      var lr = this.getAttribute('label') || '';
 
      this.innerHTML =
        (ll ? '<span class="ui-switch__label-left">' + ll + '</span>' : '') +
        '<div class="ui-switch__track"' +
          ' role="switch"' +
          ' aria-checked="' + this.checked + '"' +
          ' tabindex="' + (this.disabled ? '-1' : '0') + '">' +
          '<div class="ui-switch__thumb"></div>' +
        '</div>' +
        (lr ? '<span class="ui-switch__label-right">' + lr + '</span>' : '');
    }
 
    _update() {
      this._track.setAttribute('aria-checked', String(this.checked));
      this._track.setAttribute('tabindex', this.disabled ? '-1' : '0');
 
      var ll = this.querySelector('.ui-switch__label-left');
      var lr = this.querySelector('.ui-switch__label-right');
      if (ll) ll.textContent = this.getAttribute('label-left') || '';
      if (lr) lr.textContent = this.getAttribute('label') || '';
    }
 
    _toggle() {
      if (this.disabled) return;
      this.checked = !this.checked;
      this.dispatchEvent(new CustomEvent('change', {
        bubbles: true,
        composed: true,
        detail: { checked: this.checked }
      }));
    }
 
    _bindEvents() {
      this._track = this.querySelector('.ui-switch__track');
      this._thumb = this.querySelector('.ui-switch__thumb');
 
      this._onClick = this._toggle.bind(this);
      this._onKeyDown = function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          this._toggle();
        }
      }.bind(this);
 
      this._track.addEventListener('click', this._onClick);
      this._track.addEventListener('keydown', this._onKeyDown);
    }
  }
 
  customElements.define('ui-switch', UiSwitch);